import { CloseCircleOutlined } from '@ant-design/icons'
import { classNames } from '@shared/lib/classNames'
import { Tag, theme } from 'antd'
import type { TagProps } from 'antd/es/tag'
import './custom-tag.scss'

interface CustomTagProps extends TagProps {
    container?: boolean
    onClick?: () => void
    styleTag?: [key: string]
}

export const CustomTag = ({ color = '', onClose, children, container, onClick, styleTag }: CustomTagProps) => {
    const {
        token: { magenta, red, volcano, orange, gold, lime, green, cyan, blue, geekblue, purple }
    } = theme.useToken()

    const customColors = new Map([
        [magenta, 'magenta'],
        [red, 'red'],
        [volcano, 'volcano'],
        [orange, 'orange'],
        [gold, 'gold'],
        [lime, 'lime'],
        [green, 'green'],
        [cyan, 'cyan'],
        [blue, 'blue'],
        [geekblue, 'geekblue'],
        [purple, 'purple']
    ])

    return (
        <Tag
            className={classNames('', { close: !!onClose, 'custom-tag': !container })}
            style={{ ...styleTag }}
            color={customColors.get(color.toUpperCase()) || color}
            closable={!!onClose}
            closeIcon={<CloseCircleOutlined />}
            onClose={onClose}
            onClick={onClick}
        >
            {children}
        </Tag>
    )
}
